// import { useState, useMemo } from "react";

// const usePagination = (data = [], initialItemsPerPage = 5) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);

//   const totalItems = data.length;

//   const totalPages = useMemo(
//     () => Math.ceil(totalItems / itemsPerPage),
//     [totalItems, itemsPerPage]
//   );

//   const currentItems = useMemo(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     return data.slice(startIndex, startIndex + itemsPerPage);
//   }, [currentPage, itemsPerPage, data]);

//   const goToPage = (page) => {
//     if (page < 1) page = 1;
//     if (page > totalPages) page = totalPages;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (num) => {
//     setItemsPerPage(num);
//     setCurrentPage(1);
//   };

//   return {
//     currentPage,
//     itemsPerPage,
//     totalPages,
//     totalItems,
//     currentItems,
//     goToPage,
//     handleItemsPerPageChange,
//     setCurrentPage,
//     setItemsPerPage,
//   };
// };


// export default usePagination;
import { useState, useMemo } from 'react';

const usePagination = (data, initialItemsPerPage = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const currentItems = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  }, [data, currentPage, itemsPerPage]);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  return {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  };
};

export default usePagination;